import { OverviewBanner } from '@components/display/banners/OverviewBanner';
import { OverviewBlog, OverviewEvents, OverviewNews, OverviewVideos } from '@overview/routes/Overview';

export const Overview = () => {
    return (
        <>
            <title>Overview - Victron Professional</title>
            <OverviewBanner />
            <OverviewNews />
            <OverviewEvents />
            <OverviewVideos />
            <OverviewBlog />
        </>
    );
};
